import React from 'react';

import { UI_KIT_TEXT_TYPOGRAPHY } from '../../constants';
import { Text } from '../../text/text';

import './showcase-banner__tag.scss';

interface Props {
    text: string;
}

export const ShowcaseBannerTag = (props: Props) => {
    const { text } = props;

    return (
        <Text className="showcase-banner__tag" typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphSMedium}>
            {text}
        </Text>
    );
};
